export default "__VITE_ASSET__018f3c9c__"